import * as D from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  title: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  /** Không trả focus về phần tử cũ (khi tự điều khiển focus sau đóng). */
  noReturnFocus?: boolean;
}

export function Dialog({ open, onOpenChange, title, description, children, footer, className, noReturnFocus }: Props) {
  return (
    <D.Root open={open} onOpenChange={onOpenChange}>
      <D.Portal>
        <D.Overlay className="fixed inset-0 z-40 bg-overlay" />
        <D.Content
          onCloseAutoFocus={noReturnFocus ? (e) => e.preventDefault() : undefined}
          // Bấm vào danh sách gợi ý của Combobox (portal ngoài hộp thoại) không phải là bấm ra ngoài: không đóng hộp
          onInteractOutside={(e) => {
            if (e.target instanceof Element && e.target.closest('[data-combobox-list]')) e.preventDefault();
          }}
          className={cn(
            'fixed top-1/2 left-1/2 z-50 flex max-h-[90vh] w-[95vw] max-w-lg -translate-x-1/2 -translate-y-1/2 flex-col rounded-lg border bg-card shadow-xl outline-none',
            className,
          )}
        >
          <div className="flex items-start justify-between border-b px-4 py-3">
            <div>
              <D.Title className="text-base font-semibold">{title}</D.Title>
              {description ? <D.Description className="mt-0.5 text-xs text-muted-foreground">{description}</D.Description> : <D.Description className="sr-only">{String(title)}</D.Description>}
            </div>
            <D.Close className="rounded p-1 text-muted-foreground hover:bg-muted" aria-label="Đóng">
              <X className="size-4" />
            </D.Close>
          </div>
          <div className="min-h-0 flex-1 overflow-auto p-4">{children}</div>
          {footer && <div className="flex justify-end gap-2 border-t px-4 py-3">{footer}</div>}
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}
